import React from 'react'
import { useLanguage } from '../context/LanguageContext'

// Specialdesignede, minimalistiske og professionelle SVG-logoer for de relevante kommuner
const MUNICIPALITIES = [
  {
    name: 'Aarhus Kommune',
    // To tårne og bølger (Aarhus' historiske bysegl)
    svg: (
      <svg className="h-10 w-auto" viewBox="0 0 200 60" fill="currentColor">
        <g className="opacity-80">
          <path d="M25 15h4v22h-4zm12 0h4v22h-4z" />
          <path d="M20 37h25v3H20zm2-25c0-2 1.5-3.5 3.5-3.5s3.5 1.5 3.5 3.5S27.5 15.5 25.5 15.5 22 14 22 12zm12 0c0-2 1.5-3.5 3.5-3.5s3.5 1.5 3.5 3.5S39.5 15.5 37.5 15.5 34 14 34 12z" />
          <path d="M15 42c10 4 20-4 30 0v2c-10-4-20 4-30 0z" />
          <circle cx="33" cy="24" r="2" />
        </g>
        <text x="58" y="36" className="font-sans text-[15px] font-bold tracking-[0.15em] uppercase" fill="currentColor">AARHUS</text>
        <text x="58" y="48" className="font-sans text-[9px] tracking-[0.25em] uppercase opacity-70" fill="currentColor">KOMMUNE</text>
      </svg>
    )
  },
  {
    name: 'Odense Kommune',
    // Lilje/Fleur-de-lis og skjold (Odenses klassiske symbol)
    svg: (
      <svg className="h-10 w-auto" viewBox="0 0 200 60" fill="currentColor">
        <g className="opacity-80">
          <path d="M30 10c-1 4-3 7-6 9 4 1 7 4 8 8 1-4 4-7 8-8-3-2-5-5-6-9z" />
          <path d="M20 28c5 0 9-2 10-6 1 4 5 6 10 6-5 1-9 4-10 8-1-4-5-7-10-8z" />
          <path d="M29 38h2v6h-2z" />
        </g>
        <text x="58" y="36" className="font-sans text-[15px] font-bold tracking-[0.15em] uppercase" fill="currentColor">ODENSE</text>
        <text x="58" y="48" className="font-sans text-[9px] tracking-[0.25em] uppercase opacity-70" fill="currentColor">KOMMUNE</text>
      </svg>
    )
  },
  {
    name: 'Vejle Kommune',
    // Tre tårne over bølger (Vejles byvåben)
    svg: (
      <svg className="h-10 w-auto" viewBox="0 0 200 60" fill="currentColor">
        <g className="opacity-80">
          <path d="M18 20h6v18h-6zm11-4h6v22h-6zm11 6h6v16h-6z" />
          <path d="M15 38h34v2H15z" />
          <path d="M15 43c8 2 16-2 24 0 4 1 7 1 10 0v2c-3 1-6 1-10 0-8-2-16 2-24 0z" />
        </g>
        <text x="58" y="36" className="font-sans text-[15px] font-bold tracking-[0.15em] uppercase" fill="currentColor">VEJLE</text>
        <text x="58" y="48" className="font-sans text-[9px] tracking-[0.25em] uppercase opacity-70" fill="currentColor">KOMMUNE</text>
      </svg>
    )
  },
  {
    name: 'Horsens Kommune',
    // Hest og stiliserede blade/kløver (Horsens' historiske segl)
    svg: (
      <svg className="h-10 w-auto" viewBox="0 0 200 60" fill="currentColor">
        <g className="opacity-80">
          <path d="M22 36c2-4 5-7 9-7h6c3 0 5 2 5 5v2c0 2-2 4-4 4h-4l-3 3h-5l-1-3h-3z" />
          <path d="M38 29c1-2 3-3 5-3s3 2 3 4c0 3-3 5-5 7" />
          <circle cx="41" cy="24" r="1.5" />
          <path d="M18 42h28v2H18z" />
        </g>
        <text x="58" y="36" className="font-sans text-[15px] font-bold tracking-[0.15em] uppercase" fill="currentColor">HORSENS</text>
        <text x="58" y="48" className="font-sans text-[9px] tracking-[0.25em] uppercase opacity-70" fill="currentColor">KOMMUNE</text>
      </svg>
    )
  },
  {
    name: 'Kolding Kommune',
    // Ørn og stiliserede klipper/vand (Koldings byvåben)
    svg: (
      <svg className="h-10 w-auto" viewBox="0 0 200 60" fill="currentColor">
        <g className="opacity-80">
          <path d="M32 12c-4 2-8 6-10 10 3-1 7-1 10 0-2 3-3 7-3 11 4-2 8-2 12 0 0-4-1-8-3-11 3-1 7-1 10 0-2-4-6-8-10-10-1 2-3 3-3 3s-2-1-3-3z" />
          <path d="M20 40c6-2 12 2 18 0 3-1 5-1 8 0v2c-3-1-5-1-8 0-6 2-12-2-18 0z" />
        </g>
        <text x="58" y="36" className="font-sans text-[15px] font-bold tracking-[0.15em] uppercase" fill="currentColor">KOLDING</text>
        <text x="58" y="48" className="font-sans text-[9px] tracking-[0.25em] uppercase opacity-70" fill="currentColor">KOMMUNE</text>
      </svg>
    )
  },
  {
    name: 'Randers Kommune',
    // Nøgle og bølger (Randers' historiske segl)
    svg: (
      <svg className="h-10 w-auto" viewBox="0 0 200 60" fill="currentColor">
        <g className="opacity-80">
          <circle cx="32" cy="18" r="6" fill="none" stroke="currentColor" strokeWidth="3" />
          <path d="M32 24v16h4v-3h3v-3h-3v-3h3v-3h-7z" />
          <path d="M18 43c7 2 14-2 21 0 3 1 5 1 8 0v2c-3 1-5 1-8 0-7-2-14 2-21 0z" />
        </g>
        <text x="58" y="36" className="font-sans text-[15px] font-bold tracking-[0.15em] uppercase" fill="currentColor">RANDERS</text>
        <text x="58" y="48" className="font-sans text-[9px] tracking-[0.25em] uppercase opacity-70" fill="currentColor">KOMMUNE</text>
      </svg>
    )
  },
  {
    name: 'Silkeborg Kommune',
    // Bispehue, træer og vand (Silkeborgs byvåben)
    svg: (
      <svg className="h-10 w-auto" viewBox="0 0 200 60" fill="currentColor">
        <g className="opacity-80">
          <path d="M24 38V24l8-8 8 8v14z" />
          <path d="M32 10l-10 8h20z" />
          <circle cx="32" cy="24" r="2" />
          <path d="M16 41c8-2 16 2 24 0 3-1 5-1 8 0v2c-3-1-5-1-8 0-8 2-16-2-24 0z" />
        </g>
        <text x="58" y="36" className="font-sans text-[15px] font-bold tracking-[0.15em] uppercase" fill="currentColor">SILKEBORG</text>
        <text x="58" y="48" className="font-sans text-[9px] tracking-[0.25em] uppercase opacity-70" fill="currentColor">KOMMUNE</text>
      </svg>
    )
  },
  {
    name: 'Skanderborg Kommune',
    // Tårn og egetræ (Skanderborgs historiske segl)
    svg: (
      <svg className="h-10 w-auto" viewBox="0 0 200 60" fill="currentColor">
        <g className="opacity-80">
          <path d="M20 18h6v20h-6zm18 0h6v20h-6z" />
          <path d="M23 14h18v4H23z" />
          <path d="M32 22h2v16h-2z" />
          <path d="M16 40h32v2H16z" />
        </g>
        <text x="58" y="36" className="font-sans text-[15px] font-bold tracking-[0.15em] uppercase" fill="currentColor">SKANDERBORG</text>
        <text x="58" y="48" className="font-sans text-[9px] tracking-[0.25em] uppercase opacity-70" fill="currentColor">KOMMUNE</text>
      </svg>
    )
  },
  {
    name: 'Fredericia Kommune',
    // Løve og krone (Fredericias byvåben)
    svg: (
      <svg className="h-10 w-auto" viewBox="0 0 200 60" fill="currentColor">
        <g className="opacity-80">
          <path d="M22 14c4-2 8-2 12 0l2 4h-16z" />
          <path d="M20 22c3 0 5 2 5 5v8c0 3-2 5-5 5h-2v-18z" />
          <path d="M28 22h12v4H28zm0 8h8v4h-8z" />
        </g>
        <text x="58" y="36" className="font-sans text-[15px] font-bold tracking-[0.15em] uppercase" fill="currentColor">FREDERICIA</text>
        <text x="58" y="48" className="font-sans text-[9px] tracking-[0.25em] uppercase opacity-70" fill="currentColor">KOMMUNE</text>
      </svg>
    )
  },
  {
    name: 'Middelfart Kommune',
    // Bro og skib over bølger (Middelfarts byvåben)
    svg: (
      <svg className="h-10 w-auto" viewBox="0 0 200 60" fill="currentColor">
        <g className="opacity-80">
          <path d="M16 26c10-8 22-8 32 0v4c-10-8-22-8-32 0z" />
          <path d="M22 34h20v2H22z" />
          <path d="M16 38c8 2 16-2 24 0 3 1 5 1 8 0v2c-3 1-5 1-8 0-8-2-16 2-24 0z" />
        </g>
        <text x="58" y="36" className="font-sans text-[15px] font-bold tracking-[0.15em] uppercase" fill="currentColor">MIDDELFART</text>
        <text x="58" y="48" className="font-sans text-[9px] tracking-[0.25em] uppercase opacity-70" fill="currentColor">KOMMUNE</text>
      </svg>
    )
  }
]

export default function MunicipalLogos() {
  const { t } = useLanguage()
  // Vi duplikerer listen for at skabe en fuldstændig uendelig og sømløs rullende effekt
  const doubledMunicipalities = [...MUNICIPALITIES, ...MUNICIPALITIES, ...MUNICIPALITIES]

  return (
    <section className="relative bg-[#FAF8F5] py-12 border-b border-[#E6DFD3] overflow-hidden">
      {/* Overskrift over kommunelogoer */}
      <div className="max-w-7xl mx-auto px-4 text-center mb-6">
        <p className="text-sm font-semibold tracking-wider text-[#a78458] uppercase">
          {t('municipal.title')}
        </p>
      </div>

      {/* Infinite Marquee Container */}
      <div className="relative w-full flex items-center overflow-hidden py-4 select-none">
        {/* Venstre og højre fade-effekt for et blødt, premium look */}
        <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-r from-[#FAF8F5] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-l from-[#FAF8F5] to-transparent z-10 pointer-events-none" />

        {/* Det rullende bånd */}
        <div className="flex gap-16 sm:gap-24 animate-marquee whitespace-nowrap min-w-full">
          {doubledMunicipalities.map((item, index) => (
            <div
              key={index}
              className="inline-flex items-center justify-center text-[#2C302E]/40 hover:text-[#a78458] transition-all duration-300 transform hover:scale-105"
              title={item.name}
            >
              {item.svg}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
